var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 41,
    viewBox: "0 0 56 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M19.322 36.9381C24.2146 41.4833 31.7854 41.4833 36.6779 36.9381L51.8522 22.8411C60.3409 14.955 54.7608 0.75 43.1743 0.75H12.8258C1.23919 0.75 -4.34092 14.955 4.14779 22.8411L19.322 36.9381Z",
    fill: "#107C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.f354cb0fd1fb82f48a635cdeb215c820.svg";
export { ForwardRef as ReactComponent };